<template>
  <div class="chart-wrapper">
    <canvas ref="chart"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js';

export default {
  name: 'CampaignDonutChart',
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      chart: null
    };
  },

  mounted() {
    this.renderChart();
  },

  watch: {
    chartData: {
      deep: true,
      handler() {
        this.updateChart();
      }
    }
  },

  methods: {
    renderChart() {
      const ctx = this.$refs.chart.getContext('2d');
      
      const defaultOptions = {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 70,
        legend: {
          display: false
        },
        tooltips: {
          backgroundColor: '#2d3748',
          titleFontSize: 13,
          bodyFontSize: 12,
          padding: 12,
          cornerRadius: 8,
          callbacks: {
            label: (tooltipItem, data) => {
              const dataset = data.datasets[tooltipItem.datasetIndex];
              const total = dataset.data.reduce((acc, val) => acc + val, 0);
              const value = dataset.data[tooltipItem.index];
              const percentage = ((value / total) * 100).toFixed(1);
              return ` ${data.labels[tooltipItem.index]}: ${value.toLocaleString()} (${percentage}%)`;
            }
          }
        },
        animation: {
          animateRotate: true,
          animateScale: true
        }
      };

      this.chart = new Chart(ctx, {
        type: 'doughnut',
        data: this.chartData,
        options: { ...defaultOptions, ...this.options }
      });
    },

    updateChart() {
      if (this.chart) {
        this.chart.data = this.chartData;
        this.chart.update();
      }
    }
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
};
</script>

<style scoped>
.chart-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
